/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
//
import _ from 'lodash';
import React, { Component } from 'react';
import { Page, Layout, Card } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import Options from './feedback/options';
import Option1 from './feedback/option-1';
import Option2 from './feedback/option-2';
import Option3 from './feedback/option-3';
import Option4 from './feedback/option-4';
import AfterSubmit from './feedback/after-submit';
import { StepProgress } from 'src/components/views/theme-upgrade/step-progress';

type Props = {
  location: Object
};

type ComposedProps = Props & WithI18nProps;

type State = {
  step: number
};

class VerifyUpgrade extends Component<ComposedProps, State> {
  state = {
    step: 0
  };

  renderSwitch(step: number) {
    const themeName = _.get(this.props.location, 'state.themeName', '');

    switch (step) {
      case 0:
        return <Options handleChangeState={this.handleChangeState} />;
      case 1:
        return <Option1 handleChangeState={this.handleChangeState} themeName={themeName} />;
      case 2:
        return <Option2 handleChangeState={this.handleChangeState} />;
      case 3:
        return <Option3 handleChangeState={this.handleChangeState} />;
      case 4:
        return <Option4 handleChangeState={this.handleChangeState} />;
      case 5:
        return '';
      default:
        return <Options handleChangeState={this.handleChangeState} />;
    }
  }

  render() {
    const { step } = this.state;
    const { i18n } = this.props;

    return (
      <div className="BC-Page__Verify-Setup">
        <Page
          title={i18n.translate('AdminHTML.ThemeUpgrade.VerifyUpgrade.title')}
          primaryAction={<StepProgress step={step === 0 ? 3 : 4} />}>
          <Layout>
            <Layout.Section>
              {step !== 5 ? (
                <Card
                  sectioned
                  title={i18n.translate('AdminHTML.ThemeUpgrade.VerifyUpgrade.verifyUpgrade')}>
                  {this.renderSwitch(step)}
                </Card>
              ) : (
                <AfterSubmit />
              )}
            </Layout.Section>
          </Layout>
        </Page>
      </div>
    );
  }

  // Handle change state
  handleChangeState = (step: number) => {
    this.setState({ step });
  };
}

export default withI18n()(VerifyUpgrade);
